// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Utils
import { getMainEditorId } from '../../utils/elementEditorUtils';

// Components
import CardClipperContents from './CardClipperContents';

const CardClipper = (props) => {
    const { isEditing, documentMode, isClipping } = props;

    if (!isClipping && (!isEditing || !!documentMode)) return null;

    return <CardClipperContents {...props} editorId={getMainEditorId(props)} />;
};

CardClipper.propTypes = {
    isEditing: PropTypes.bool,
    documentMode: PropTypes.bool,
    editorState: PropTypes.object,

    isClipping: PropTypes.bool,
    onClipStart: PropTypes.func,
    onClipEnd: PropTypes.func,
};

export default CardClipper;
